<script>

  import { onMount } from "svelte";
  import { fetchData } from './ajaxHelpers';
  import TickerBox from './tickerBox.svelte';

  let quoteData = [];

  onMount(() => {
    fetchData(`/ajax/stock_quotes.json`,
      r => { quoteData = r }
    );
  });

</script>

<div class="ticker-container hidden-xs">
{#each quoteData as stock, i}
  <TickerBox {stock} />
  {#if i < (quoteData.length-1)}
    <div class="ticker-divider"></div>
  {/if}
{/each}
</div>
